import { BrainInterface, BrainResultInterface, GroupInterface, Slug } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Brain/Brains.Controller.ts
export class BrainsAPI {
  static async getBrains(orgId: number) {
    return APIService.Server.get<{ [slug: string]: BrainInterface }>(`/brains/org/${orgId}`);
  }
  // static async getBrainById(orgId: number, brainId: number) {
  //   return APIService.Server.get<BrainInterface>(
  //     `/brains/org/${orgId}/brain/${brainId}`
  //   );
  // }
  static async getBrainBySlug(orgId: number, slug: Slug) {
    return APIService.Server.get<BrainInterface>(`/brains/org/${orgId}/slug/${slug}`);
  }

  static async createBrain(orgId: number, brain: Partial<BrainInterface>) {
    return APIService.Server.post<BrainInterface>(`/brains/org/${orgId}/brain`, brain);
  }
  static async updateBrain(orgId: number, brain: BrainInterface) {
    return APIService.Server.put<BrainInterface>(`/brains/org/${orgId}/brain/${brain.id}`, brain);
  }
  static async deleteBrain(orgId: number, brainId: number) {
    return APIService.Server.delete(`/brains/org/${orgId}/brain/${brainId}`);
  }

  static async saveBrainResults(orgId: number, results: Partial<BrainResultInterface>) {
    return APIService.Server.post<BrainResultInterface>(`/brains/org/${orgId}/brain-results`, results);
  }

  static async getBrainResults(
    orgId: number,
    params?: {
      limit?: number;
      offset?: number;
      archived?: boolean;
      startDate?: string;
      endDate?: string;
      excludeDeleted?: boolean;
    }
  ) {
    let url = `/brains/org/${orgId}/brain-results`;
    const queryParts: string[] = [];

    if (params?.limit !== undefined) queryParts.push(`limit=${params.limit}`);
    if (params?.offset !== undefined) queryParts.push(`offset=${params.offset}`);
    if (params?.archived !== undefined) queryParts.push(`archived=${params.archived}`);
    if (params?.startDate) queryParts.push(`startDate=${params.startDate}`);
    if (params?.endDate) queryParts.push(`endDate=${params.endDate}`);
    if (params?.excludeDeleted !== undefined) queryParts.push(`excludeDeleted=${params.excludeDeleted}`);

    if (queryParts.length > 0) {
      url += "?" + queryParts.join("&");
    }

    return APIService.Server.get<{ results: BrainResultInterface[]; total: number }>(url);
  }

  static async searchBrainResults(
    orgId: number,
    query: string,
    params?: {
      limit?: number;
      offset?: number;
      archived?: boolean;
      excludeDeleted?: boolean;
    }
  ) {
    let url = `/brains/org/${orgId}/brain-results/search?query=${encodeURIComponent(query)}`;

    if (params?.limit !== undefined) url += `&limit=${params.limit}`;
    if (params?.offset !== undefined) url += `&offset=${params.offset}`;
    if (params?.archived !== undefined) url += `&archived=${params.archived}`;
    if (params?.excludeDeleted !== undefined) url += `&excludeDeleted=${params.excludeDeleted}`;

    return APIService.Server.get<{ results: BrainResultInterface[]; total: number }>(url);
  }
}
